// ============ SELEZIONE: cambia queste due righe prima di buildare ============
const CLIENT = "frey"; // "default" | "acme" | ...
const ENV = "prod"; // "prod" | "stag"

// ============ CLIENTI (branding + endpoint API per ambiente) ============
const CLIENTS = {
  frey: {
    name: "FREY",
    logo: require("@/assets/images/property_logo_frey.png"),
    api: {
      prod:
        "https://az-nego-app-dashboard-prd-gzejcrexf4b3gsga.francecentral-01.azurewebsites.net",
      stag:
        "https://az-nego-app-dashboard-qua-c4bhdzghbscnfefk.francecentral-01.azurewebsites.net",
    },
  },
  lof: {
    name: "FREY",
    logo: require("@/assets/images/property_logo_frey.png"),
    api: {
      prod: "https://nego-dashprd.azurewebsites.net",
      stag: "https://nego-dashqua.azurewebsites.net",
    },
  },
  acme: {
    name: "Acme",
    logo: require("@/assets/branding/acme/logo.png"),
    api: {
      prod: "https://acme-prod.example.azurewebsites.net",
      stag: "https://acme-qua.example.azurewebsites.net",
    },
  },
};

const client = CLIENTS[CLIENT] || CLIENTS.frey;
const baseURLRoot = client.api[ENV]; // risolto da CLIENT × ENV
const branding = { name: client.name, logo: client.logo };

module.exports = { baseURLRoot, branding };
